module.exports = __webpack_public_path__ + "img/3_84.22ee4274.png";